export default ({ guestTeamData, homeTeamData }) => {
  // const status = whoHasTheBall(report);
  // '["4-4-2","4-3-3","4-5-1","5-4-1","5-3-2","3-4-2-1","3-4-3","3-5-2","3-6-1","4-2-3-1","4-4-1-1"]'
  return  (`
    <div class="lineups">
        <img src="/assets/images/stat.jpeg" class="lineups__stat m-0 d-flex w-100" alt="" />
        <div class="lineups__team home" data-formation="${homeTeamData?.team?.formation_name}">
            ${Object.values(homeTeamData?.positions||[])?.map((item, index) => `
              <div class="lineups__player lineups__player--a d-flex flex-column justify-content-center" data-number="${index + 1}">
                <div style="position: relative; text-align: center;">
                  <span class="lineups__player-number">${index + 1}</span>
                  <img src="/assets/images/jrseya.png" alt="" width="60" height="100">
                  <div class="ball xs ball-hidden js-ball-item fade-out" data-nft-id=${item.nft_id} style=" font-size: 30px; position: absolute; left: 0; bottom: 0;">
                    <div></div>
                  </div>
                </div>
                <span class="lineups__player-name">${item.name}</span>
              </div>
            `).join('')}
        </div>

        <div class="lineups__team guest" data-formation="${guestTeamData?.team?.formation_name}">
            ${Object.values(guestTeamData?.positions||[])?.map((item, index) => `
              <div class="lineups__player lineups__player--b d-flex flex-column justify-content-center" data-number="${index + 1}">
                  <div class="" style="position: relative; text-align: center;">
                    <span class="lineups__player-number">${index + 1}</span>
                    <img src="/assets/images/jrseyb.png" alt="" width="60" height="100">
                    <div class="ball xs ball-hidden js-ball-item fade-out" data-nft-id=${item.nft_id} style=" font-size: 30px; position: absolute; left: 0; bottom: 0;">
                      <div></div>
                    </div>
                  </div>
                  <span class="lineups__player-name">${item.name}</span>
              </div>
            `).join('')}
        </div>

        <div class="js-message lineups__message">
          <div class="ball">
            <div></div>
          </div>
        </div>
    </div>
  `);
};
